import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID, values = null,action=null,descripcion) {
    
    let valueStatus='N';
    let tipoAccion ='false';
    if(action){
      valueStatus = 'S';
      tipoAccion ='true';
    }

    const data =  {
      codColaborador: [    ],
      codFiveAdj:values.codFiveAdj ,
      codTipoAdj: values.codTipoAdj,
      codUsuario: IDUSUARIO,
      indInactivo: valueStatus,
      nomAdj: values.nomAdj,
      numFichaVtaVeh: fdvID,
      txtRutaFire: values.txtRutaFire,
      labelTipo:descripcion,
    };
    
    const config = {
        headers: {
          tipoAccion:tipoAccion,
          idUsuario: IDUSUARIO,
        },  
      };
  
      return  customAxios.put(`${FDV_URL}/archivoAdjunto/adjuntar/${values.codFiveAdj}`,data ,config);
     
    }


// WEBPACK FOOTER //
// ./src/utils/editAdjunto.js